import { defineMessages } from 'react-intl';
export default defineMessages({
    alreadyHaveAccount: {
        id: 'intro.alreadyHaveAccount',
        defaultMessage: 'Already have an account?'
    },
    allowLocation: {
        id: 'intro.allowLocation',
        defaultMessage: 'Allow location'
    },
    connectStationDescription: {
        id: 'intro.connectStationDescription',
        defaultMessage: "Pick your service. You'll sign in to connect it."
    },
    connectStationTitle: {
        id: 'intro.connectStationTitle',
        defaultMessage: 'Connect your station'
    },
    haveWeatherStation: {
        id: 'intro.haveWeatherStation',
        defaultMessage: 'I have a weather station'
    },
    showWeatherHere: {
        id: 'intro.showWeatherHere',
        defaultMessage: 'Show the weather where I am'
    },
    showWeatherInstead: {
        id: 'intro.showWeatherInstead',
        defaultMessage: 'Not now, show me the weather'
    },
    locationDescription: {
        id: 'intro.locationDescription',
        defaultMessage: 'Enable location access to get accurate weather predictions tailored to your exact area — no more one-size-fits-all forecasts.'
    },
    locationTitle: {
        id: 'intro.locationTitle',
        defaultMessage: 'Forecasts Made for You'
    },
    welcomeDescription: {
        id: 'intro.welcomeDescription',
        defaultMessage: 'Get hyperlocal forecasts powered by top weather agencies — plus access to 40,000+ weather stations worldwide to see real-world conditions, past and present.'
    },
    welcomeTitle: {
        id: 'intro.welcomeTitle',
        defaultMessage: 'Your Weather, Reimagined'
    }
});
